import { render, staticRenderFns } from "./FormPrice.vue?vue&type=template&id=eb0c4714&scoped=true"
import script from "./FormPrice.vue?vue&type=script&lang=js"
export * from "./FormPrice.vue?vue&type=script&lang=js"
import style0 from "./FormPrice.vue?vue&type=style&index=0&id=eb0c4714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0c4714",
  null
  
)

export default component.exports